"use client";

import React from 'react';
import { ThemeProvider } from './ThemeProvider';
import { SessionProvider } from "next-auth/react";
import { useEffect } from "react";

interface ClientProvidersProps {
  children: React.ReactNode;
}

const ClientProviders: React.FC<ClientProvidersProps> = ({ children }) => {
  // Disable debug logging
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      console.debug = () => {};
    }
  }, []);

  return (
    <SessionProvider>
      <ThemeProvider defaultTheme="dark" storageKey="theme-preference">
        {children}
      </ThemeProvider>
    </SessionProvider>
  );
};

export default ClientProviders;